import React from "react";
import { Node_Type } from "./../../ricos-types/index.js";
import File from "./file.js";
const FileRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(File, { key: node.id, node, ...props });
};
const nodeViewRenderers = {
  [Node_Type.FILE]: FileRenderer
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
